export const environment = {
    production: false,
    // apiUrl:'https://hotel-inventory.traversia.net/api'
    // apiUrl:'http://4.240.86.26:8000/api'
    apiUrl:'https://dev-hotel-inventory.traversia.net/api'
    // apiUrl: 'http://localhost:3002/api',
  };
  